import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of, throwError } from 'rxjs';
import { Value } from '../../domain/value.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ValueService {
  constructor(private api: ApiService) {}

  getValues(formId: string, versionId: string): Observable<any[]> {
    console.log('Get Values')    
    return this.api.get(`/forms/${formId}/versions/${versionId}/values`);
  }
  getValue(formId: string, versionId: string, value: Value): Observable<{ content: Value }> {
    return this.api.get(`/forms/${formId}/versions/${versionId}/${value.sk}`);
  }

}
